<template>
  <v-card max-width="1000" class="pa-0 mx-auto" :loading="loading">
    <v-toolbar color="primary">
      <v-toolbar-title
        ><h1>{{ $t("info.system") }}</h1>
      </v-toolbar-title>
    </v-toolbar>
    <h2 class="text-center pt-2">
      {{ $t("info.admityear") }} : {{ admitSemester }} / {{ admitYear }}
    </h2>
    <div class="text-center pt-1">
      <v-chip color="#ddd" variant="flat" class="py-1 px-7"
        ><h3>
          {{ $t("info.undergraduate") }}
        </h3></v-chip
      >
    </div>
    <div class="text-center my-5">
      <v-btn
        color="warning"
        variant="flat"
        elevation="5"
        :href="
              $root.$i18n.locale === 'en'
                ? 'https://www.reg.kmitl.ac.th/storage/kmitl1/info/undergraduate/recommendation_en.pdf'
                : 'https://www.reg.kmitl.ac.th/storage/kmitl1/info/undergraduate/recommendation.pdf'
            "
        target="_blank"
        >{{ $t("info.ungrad_recommendation") }}</v-btn
      >
    </div>
    <h1 class="text-center pt-1 mb-3">
      {{ $t("info.maininfo") }}
    </h1>
    <div class="custom-card">
      <v-card>
        <v-card-text class="mx-0 mx-md-2 mb-2 px-0 px-md-2 px-xl-4">
          <h3 class="text-center pb-2">
            <v-icon class="pb-1">mdi-information-slab-box</v-icon>
            {{ $t("info.info") }}
          </h3>
          <a
            target="_blank"
            :href="
              $root.$i18n.locale === 'en'
                ? 'https://www.reg.kmitl.ac.th/storage/kmitl1/info/undergraduate/undergraduate_EN.png'
                : 'https://www.reg.kmitl.ac.th/storage/kmitl1/info/undergraduate/undergraduate_TH.png'
            "
          >
            <v-img
              :src="
                $root.$i18n.locale === 'en'
                  ? 'https://www.reg.kmitl.ac.th/storage/kmitl1/info/undergraduate/undergraduate_EN.png'
                  : 'https://www.reg.kmitl.ac.th/storage/kmitl1/info/undergraduate/undergraduate_TH.png'
              "
              style="border: 0px solid #ddd; border-radius: 8px"
            >
            </v-img>
          </a>
          <div class="text-center">
            <v-chip
              class="bordered-pn mt-2 mx-auto py-0 py-sm-1"
              color="success"
              ><h5>
                {{ $t("info.open") }}
              </h5>
            </v-chip>
            <br />
            <v-chip class="bordered-pn mt-2 mx-auto py-0 py-sm-1" color="error"
              ><h5>
                {{ $t("info.close") }}
              </h5>
            </v-chip>
          </div>
        </v-card-text>
        <v-card-text class="mx-0 mx-md-2 mb-2 px-0 px-md-2 px-xl-4"
          ><h3 align="center" justify="center" class="pa-0">
            <v-icon>mdi-text-box-multiple</v-icon>
            {{ $t("info.documentform") }}
          </h3>
          <h4 class="text-center mt-2">
            {{ $t("info.select") }}
          </h4>
          <v-table class="my-2 bordered-table">
            <thead>
              <tr>
                <th class="text-center" style="width: 60%">
                  <h4>{{ $t("info.form") }}</h4>
                </th>
                <th class="text-center">
                  <h4>{{ $t("info.version_th") }}</h4>
                </th>
                <th class="text-center">
                  <h4>{{ $t("info.version_en") }}</h4>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t("info.doc1") }}</td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/storage/kmitl1/form/undergraduate/form1_th.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="error"
                      icon="mdi-file-download"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/storage/kmitl1/form/undergraduate/form1_en.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="error"
                      icon="mdi-file-download"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
              </tr>
              <tr>
                <td>
                  {{ $t("info.doc2") }}
                </td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/storage/kmitl1/form/undergraduate/form2_th.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="error"
                      icon="mdi-file-download"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/storage/kmitl1/form/undergraduate/form2_en.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="error"
                      icon="mdi-file-download"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
              </tr>
            </tbody>
          </v-table>
        </v-card-text>
      </v-card>
    </div>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
import PublicProvider from "@/services/public.provider.js";
const publicProvider = new PublicProvider();
// @ is an alias to /src

export default {
  name: "InfoView",

  data: () => ({
    loading: false,
    tabs: 1,
    levelId: "1",
    yearId: 0,
    admitYear: null,
    admitSemester: null,
  }),

  methods: {
    async fetch_data(levelInput) {
      this.loading = true;

      if (!levelInput) {
        levelInput = 1;
      }
      const data1 = await publicProvider
        .getCurrentYear(levelInput)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });
      if (data1) {
        this.yearId = data1.YEAR_ID;
        this.admitYear = data1.ADMIT_YEAR;
        this.admitSemester = data1.ADMIT_SEMESTER;
      }

      this.loading = false;
    },
    handleTabClick(tab) {
      this.$router.push({ path: "/info", query: { tab } });
    },
    fetch_data_from_url() {
      const tab = parseInt(this.$route.query.tab);
      this.fetch_data(tab);
    },
  },

  watch: {
    "$route.query.tab"(newValue = 1) {
      this.tabs = parseInt(newValue);
      this.levelId = newValue;
      this.fetch_data(this.levelId);
    },
  },

  created() {
    const tab = parseInt(this.$route.query.tab);
    this.tabs = tab;
    this.fetch_data_from_url();
  },
};
</script>

<style scoped>
.shadow-text {
  text-shadow: 0px 0px 3px #919191;
}
.custom-card .v-card-text {
  border: 1px solid #dadada;
  border-radius: 0px;
}
.bordered-table {
  border: 1px solid #ddd; /* Customize border style, color, etc. */
  border-radius: 8px;
}

.bordered-pn {
  border: 1px dashed;
}

.v-chip {
  height: auto !important;
  white-space: normal;
}
</style>
